import axios, { AxiosResponse } from 'axios';

import { IOnboardingDataPayload } from '../models/OnboardingNotifications';
import { GET_USER_API, ROOT_URL, UPDATE_USER_ONBOARDING_API } from '../main/constants/endpoints';

interface IGetOnboardingNotificationsPayload {
    on_boarding: IOnboardingDataPayload;
}

export const getOnboardingNotificationsData = async (): Promise<IOnboardingDataPayload> => {
    const { data }: AxiosResponse<IGetOnboardingNotificationsPayload> = await axios.get(`${ROOT_URL}/${GET_USER_API}`, {
        withCredentials: true,
        headers: { Pragma: 'no-cache' },
    });

    return data.on_boarding;
};

export const saveOnboardingNotifications = async (onboardingNotificationsData: IOnboardingDataPayload) => {
    await axios.patch(
        `${ROOT_URL}/${UPDATE_USER_ONBOARDING_API}`,
        {
            on_boarding: onboardingNotificationsData,
        },
        {
            withCredentials: true,
        }
    );
};
